import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "o-listing-filters o-list__listing-filters"
}
const _hoisted_2 = { class: "o-list__container c-wrapper c-wrapper--with-padding c-wrapper--with-padding--x" }
const _hoisted_3 = {
  key: 3,
  class: "text--center o-list__button"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TpxFilterMenu = _resolveComponent("TpxFilterMenu")!
  const _component_TpxListing = _resolveComponent("TpxListing")!
  const _component_TpxParagraph = _resolveComponent("TpxParagraph")!
  const _component_TpxButton = _resolveComponent("TpxButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["o-list", _ctx.colourClasses]),
    ref: "root"
  }, [
    (_ctx.hasFilters)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_TpxFilterMenu, {
            filterGroups: _ctx.filterGroups,
            ref: "filterMenu"
          }, null, 8, ["filterGroups"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "list", {}, () => [
        _createVNode(_component_TpxListing, {
          class: "o-list__list",
          backgroundColour: _ctx.backgroundColour,
          imageHoverEffect: _ctx.imageHoverEffect,
          items: _ctx.activeItems
        }, null, 8, ["backgroundColour", "imageHoverEffect", "items"]),
        (_ctx.hasErrored)
          ? (_openBlock(), _createBlock(_component_TpxParagraph, {
              key: 0,
              class: "text--center text--red",
              content: "There was an error retrieving data for this list"
            }))
          : _createCommentVNode("", true),
        (_ctx.hasErrored)
          ? (_openBlock(), _createBlock(_component_TpxParagraph, {
              key: 1,
              class: "text--center text--red"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_TpxButton, {
                  class: "o-list__retry",
                  content: "Retry",
                  onClick: _ctx.loadData
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_TpxParagraph, {
              key: 2,
              class: "padding text--center",
              content: "Loading..."
            }))
          : _createCommentVNode("", true),
        (_ctx.hasMore)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_TpxButton, {
                content: "Load more",
                class: "a-button--primary",
                textColour: _ctx.featureColour,
                onClick: _ctx.loadMore
              }, null, 8, ["textColour", "onClick"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}